import React from "react";

const Location = () => {
  return (
    <div className=" flex flex-col gap-8 py-10 mx-auto">
      <h2 className="text-3xl font-bold text-center">
        Visit Our Offline Store
      </h2>
      <iframe
        className="mx-auto max-w-[90vw]"
        title="location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14737.416527139429!2d88.3552963!3d22.5658547!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02778187e10f77%3A0x53d3b2436d1b240b!2sABS%20Infotech!5e0!3m2!1sen!2sin!4v1724318640869!5m2!1sen!2sin"
        width={900}
        height={450}
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default Location;
